import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ReadMoreComponent extends Vue {
    
    @Prop() text: string;
    @Prop() maxLength: number;

    collapsed = true;

    get textTooLong() {
        return this.text.length > this.maxLength;
    }

    get displayText() {
        if (this.collapsed && this.textTooLong) {
            return `${this.text.slice(0, this.maxLength)}...`;
        }
        return this.text;
    }
}
